import {defineMessages} from 'react-intl';

export default defineMessages({
	new: {
		id: 'flyout.myAccount.orders.orderStatusNew',
		defaultMessage: 'Order placed',
	},
	shipped: {
		id: 'flyout.myAccount.orders.orderStatusShipped',
		defaultMessage: 'Shipped',
	},
	partly_shipped: {
		id: 'flyout.myAccount.orders.orderStatusPartlyShipped',
		defaultMessage: 'Partly Shipped',
	},
	picked_up: {
		id: 'flyout.myAccount.orders.orderStatusPickedUp',
		defaultMessage: 'Picked Up',
	},
	partly_picked_up: {
		id: 'flyout.myAccount.orders.orderStatusPartlyPickedUp',
		defaultMessage: 'Partly Picked Up',
	},
	ready_for_pickup: {
		id: 'flyout.myAccount.orders.orderStatusReadyForPickup',
		defaultMessage: 'Ready for Pickup',
	},
	ready_for_partial_pickup: {
		id: 'flyout.myAccount.orders.orderStatusReadyForPartialPickup',
		defaultMessage: 'Ready for Partial Pickup',
	},
	being_processed: {
		id: 'flyout.myAccount.orders.orderStatusProcessing',
		defaultMessage: 'Being Processed',
	},
	in_review: {
		id: 'flyout.myAccount.orders.orderStatusInReview',
		defaultMessage: 'In review',
	},
	canceled: {
		id: 'flyout.myAccount.orders.orderStatusCanceled',
		defaultMessage: 'Cancelled',
	},
	returned: {
		id: 'flyout.myAccount.orders.orderStatusReturned',
		defaultMessage: 'Returned',
	},
	refunded: {
		id: 'flyout.myAccount.orders.orderStatusRefunded',
		defaultMessage: 'Refunded',
	},
	not_confirmed: {
		id: 'flyout.myAccount.orders.orderStatusNotConfirmed',
		defaultMessage: 'Not confirmed',
	},
	in_progress: {
		id: 'flyout.myAccount.orders.orderStatusInProgress',
		defaultMessage: 'In review',
	},
	partly_returned: {
		id: 'flyout.myAccount.orders.orderStatusPartlyReturned',
		defaultMessage: 'In review',
	},
	confirmed: {
		id: 'flyout.myAccount.orders.orderStatusConfirmed',
		defaultMessage: 'Processed',
	},
	open: {
		id: 'flyout.myAccount.orders.orderStatusOpen',
		defaultMessage: 'In review',
	},
});
